import React, { Suspense } from "react";

const BallCanvas = ({ icon }) => {
  return (
    <>
      <img src={icon} alt="" />
    </>
  );
};

export default BallCanvas;
